import React, { useEffect } from "react";

import Main from '../components/CFD/Main'
import Advantages from "../components/CFD/Advantages";
import WhyShould from "../components/CFD/WhyShould";

function CFD () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div>
            <Main/>
            <Advantages/>
            <WhyShould/>
        </div>
    );
}

export default CFD;